// «Dale a este libro su carpeta»: lo primero que ve quien abre el panel con un documento que empieza en una carpeta
// de todo (Descargas, Escritorio…). No le pregunta nada a Word: la ruta del documento ya la sabe el panel.
import { useEffect, useState } from "react";
import { type EstadoDeLaCarpeta, type CarpetaDada, hayQueOfrecerCarpeta, yaTieneSuCopia, TITULO_DE_LA_CARPETA, TITULO_DE_LA_COPIA, fraseDeLaCarpeta, fraseDeLaCopia, fraseDeLoQueHara, ROTULO_DAR_CARPETA, ROTULO_ABRIR_LA_COPIA, fraseDeCarpetaDada, claveDeAhoraNo } from "./carpetaLogica";

const COMPANION = "https://localhost:3001";
const recuerda = (k: string) => { try { return localStorage.getItem(k) === "1"; } catch { return false; } };

export default function CarpetaDelLibro({ ruta }: { ruta: string }) {
  const [estado, setEstado] = useState<EstadoDeLaCarpeta>(null);
  const [dijoQueNo, setDijoQueNo] = useState(false);
  const [ocupado, setOcupado] = useState(false);
  const [dada, setDada] = useState<CarpetaDada | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setEstado(null); setDada(null); setError(null);
    if (!ruta) return;
    let vivo = true;
    // Un motor anterior no sabe contestar: entonces no se dice nada.
    fetch(`${COMPANION}/carpeta?doc=${encodeURIComponent(ruta)}`).then((r) => (r.ok ? r.json() : null))
      .then((e: EstadoDeLaCarpeta) => { if (vivo && e) { setEstado(e); setDijoQueNo(recuerda(claveDeAhoraNo(e.carpeta))); } })
      .catch(() => { /* sin motor, el panel ya lo dice en otro sitio */ });
    return () => { vivo = false; };
  }, [ruta]);

  async function dar() {
    setOcupado(true); setError(null);
    try {
      const r = await fetch(`${COMPANION}/carpeta/dar`, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ doc: ruta }) });
      const j = await r.json();
      if (!r.ok) { setError(j.error || "No he podido crear la carpeta. No se ha tocado nada."); return; }
      setDada(j);
    } catch { setError("No consigo hablar con HumanInk en este ordenador. No se ha tocado nada."); }
    finally { setOcupado(false); }
  }
  function ahoraNo() {
    try { localStorage.setItem(claveDeAhoraNo(estado?.carpeta), "1"); } catch { /* sin almacenamiento, se pregunta otra vez */ }
    setDijoQueNo(true);
  }

  if (dada) return (
    <div role="status" style={{ ...caja, borderColor: "var(--hi-bien-raya)", background: "var(--hi-bien-fondo)" }}>
      <div style={{ fontSize: 12, overflowWrap: "anywhere" }}>{fraseDeCarpetaDada(dada)}</div>
    </div>
  );
  // Ya se le dio carpeta y se ha vuelto a abrir el original: no se ofrece otra, se le recuerda la suya.
  const conCopia = yaTieneSuCopia(estado, dijoQueNo);
  if (!conCopia && !hayQueOfrecerCarpeta(estado, dijoQueNo)) return null;
  return (
    <div style={caja}>
      <div style={{ fontWeight: 800, fontSize: 13, marginBottom: 4 }}>{conCopia ? TITULO_DE_LA_COPIA : TITULO_DE_LA_CARPETA}</div>
      {conCopia
        ? <div style={{ fontSize: 12, color: "var(--hi-tenue)", marginBottom: 8, overflowWrap: "anywhere" }}>{fraseDeLaCopia(estado)}</div>
        : <>
          <div style={{ fontSize: 12, color: "var(--hi-tenue)", marginBottom: 6 }}>{fraseDeLaCarpeta(estado)}</div>
          <div style={{ fontSize: 12, color: "var(--hi-tenue)", marginBottom: 8, overflowWrap: "anywhere" }}>{fraseDeLoQueHara(estado)}</div>
        </>}
      <button onClick={dar} disabled={ocupado} style={{ width: "100%", padding: "10px 8px", borderRadius: 10, border: "none", cursor: "pointer", fontWeight: 800, fontSize: 13, background: "var(--hi-menu-activo)", color: "var(--hi-sobre-acento)", opacity: ocupado ? 0.6 : 1 }}>
        {ocupado ? (conCopia ? "Abriendo…" : "Creando la carpeta…") : conCopia ? ROTULO_ABRIR_LA_COPIA : ROTULO_DAR_CARPETA}
      </button>
      {error && <div role="alert" style={{ fontSize: 12, color: "var(--hi-mal)", marginTop: 6 }}>{error}</div>}
      <div style={{ marginTop: 6, textAlign: "right" }}>
        <button onClick={ahoraNo} style={{ background: "none", border: "none", color: "var(--hi-apagado)", cursor: "pointer", fontSize: 11, padding: 0 }}>Ahora no</button>
      </div>
    </div>
  );
}
const caja = { border: "1px solid var(--hi-aviso)", borderRadius: 10, padding: 10, marginBottom: 12 } as const;
